/** @import modules */

import { useTranslation }           from "react-i18next";

import { useParams, useNavigate }   from "react-router-dom";

import { useQuery }                 from "@apollo/client";

/** @import hooks */

import { STUDS_ENUM }               from "../../../../../Queries/Tyres";

import { TyresNavigator }           from "../../../../../Hooks/TyresNavigator";

import ComponentLoader from "../../../../Layout/Loaders/Loader";

/** @import components */

import SearchableSelect             from "../../../../Shared/SearchableSelect";

/**
 * 
 * @param { attributes } param0 
 * 
 * @returns StudsFilter filter component
 * 
 */

const StudsFilter = ( { attributes } ) => { const 

    { t }               = useTranslation    (),

    navigate            = useNavigate       (),

    { parameters }      = useParams         (),

    { loading, data } = useQuery ( STUDS_ENUM  ),

    Filter = ( value ) => { const 

        object = { f : 12, l: null, a: null, b: null, st: ( value === "default" ) ? null : value, loc: window.scrollY };

        return navigate (  
            
            `/shop/tyres/${
            
                new URLSearchParams ( TyresNavigator ( parameters, object ) ).toString () }` );

    };

    /** @return component */

    return ( <div className="content vehicle-type">

        { loading ? <ComponentLoader minified={ true } /> : 

            <div className="select shadow-select">

                <SearchableSelect
                    options={ data.__type.enumValues.map ( v => ( { text: t ( `studs_${ v.name }` ), value: v.name } ) ) }
                    value={ new URLSearchParams ( parameters ).get ( "st" ) || "default" }
                    onChange={ Filter }
                    label={ t ( "select_option" ) }
                />

            </div>

        }

    </div> );

}

/** @export StudsFilter */
 
export default StudsFilter;